import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class UpiVpa extends Component {
    state = {
        upiVpaList:[],
        upiVpaValue: null,
        isVpaLoading: true
    };
    componentDidMount(){
        this._getUpiVpa();

//         if(this.props.object_type==='Merchant'){
//             var merchantData = [];
//             this.props.object_code.map((value, index) => {
//                 merchantData.push({"value": value, "label": ""})
//             })
//                 this.changeMerchant('merchant', merchantData);
//             }
    }
    restVpaFilter() {
        this.setState({
            upiVpaValue: [],
        })
    }
    _getUpiVpa(){
        axios.get(config.get('API_URL')+'/filters/get-upi-vpa/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((vpa, index) => {
                    mList.push({value: vpa.vpa, label: vpa.vpa})
                });
                this.setState({
                    upiVpaList:mList,
                    isVpaLoading: false
                })
            }
        });
    }
    changeVpa(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (this.props.object_type != 'Merchant') {
                    var index = this.state.upiVpaList.findIndex(obj => obj.value == mids.value);
                    this.state.upiVpaList.move(index, 0).join(',');
                }
            });
        }
        this.props.onSelectUpiVpa(optionSelected, midArray);
        this.setState({
            upiVpaValue:optionSelected,
        });

    }
    render() {
        return (
            <ReactMultiSelectCheckboxes name="vpa"
                isMulti
//                 components={{ MenuList }}
                value={this.state.upiVpaValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeVpa.bind(this,'')}
                options={this.state.upiVpaList}
                placeholderButtonLabel="Select [VPA]"
                isLoading={this.state.isVpaLoading}
            />
        );

    }
}
export default UpiVpa;